export default "__VITE_ASSET__OYHOVjWr__"